const reqVideos = {
	modulos: (api) => {
		return api
			.get(`v1/videos/modulos`, {
				headers: {
					banco: "bdsz",
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	grupos: (api, id_modulo) => {
		return api
			.get(`v1/videos/grupos`, {
				params: { id_modulo },
				headers: {
					banco: "bdsz",
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqVideos;
